<template>
  <Button
    :label="label"
    :severity="severity"
    :disabled="disabled"
    :loading="loading"
    :pt="{
      loadingIcon: '!size-xl'
    }"
    @click="onClick"
  >
    <template v-if="icon" #icon>
      <OutlinedIcon class="text-xl" :icon="icon" />
    </template>
  </Button>
</template>

<script setup lang="ts">
import {PropType} from 'vue';
import {SeverityType} from '@common/types';
import {OutlinedIcon} from '@common/ui';
import Button from 'primevue/button';

// Props
defineProps({
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  icon: {
    type: String,
    required: false,
  },
  label: {
    type: String,
    required: false,
  },
  loading: {
    type: Boolean,
    required: false,
  },
  severity: {
    type: String as PropType<SeverityType>,
    required: false,
  },
});

// Events
const emit = defineEmits<{
  (e: 'click', event: Event): void
}>();

// Methods
const onClick = (e: Event) => {
  emit('click', e);
};
</script>
